import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a7e45d4bedae70014f73b5e_1786974574592_28e6ceff/lifediver/src/app/sign-up-login/components/AuthPage.tsx");
